import React, {Component} from 'react';
import News1Container from 'News1/container.js'
//import initialLoad from 'utils/initialLoad'

class News1Route extends Component {

  render() {
    return (
      <News1Container />
    )
  }
}

export default News1Route;


// WEBPACK FOOTER //
// ./src/routes/News-1.js